import React, {Component} from 'react';
import {Modal, Button}  from 'react-bootstrap'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faThumbsUp, faThumbsDown } from '@fortawesome/free-solid-svg-icons';
import SecondServer from '../database/SecondServer'
import { urlDeleteGrantRequest, urlGrant } from '../database/apiUrls';
import { RowOfChildren, GridText, clickToNamedClass } from '../Report/RenderHelpers';
import { httpSuccess } from '../Utils/status';
import { GrantRequests } from './GrantRequests';
import { renderLoader } from "../Loading/loading";
import ExpireInput from './ExpireInput';

import '../Report/report-header.css'
import '../Report/Controls/massedit.css'
import '../commoninputs.css'
import '../Sites/siteadd.css'

export default class GrantApprove extends Component {
  constructor(props) {
    super(props);
  
    this.state = {
      requests: undefined,
      errMsg: undefined,
      saving: false,
      datePicker: false,
      expDate: new Date(),
      prevIndex: undefined,
      loader: renderLoader()
    }
    this.state.expDate.setMonth(this.state.expDate.getMonth() + 3)
    this.handleClose = this.handleClose.bind(this);
    this.denyRequest = this.denyRequest.bind(this)
    this.approveRequest = this.approveRequest.bind(this)
    this.customGrant = this.customGrant.bind(this)
    this.newDate = this.newDate.bind(this)
    this.blurCalendar = this.blurCalendar.bind(this)
    this.ss = undefined
  }

  componentDidMount() {
    this.ss = new SecondServer(this.props)
    this.initState();
  }

  componentDidUpdate(prevProps) {
    if (prevProps?.show !== this.props?.show)
      this.initState();
  }

  async initState () {
    const data = await GrantRequests (this.props)
    this.setState ({requests: data.req, errMsg: data.errMsg})
  }

  async handleClose() {
    this.props.hide();
  }
  actButtonIndex (evt) {
    const btn= clickToNamedClass(evt, "actButton")
    return btn.getAttribute('index')
  }
  async addGrant (req, dt) {
    const url = urlGrant()
    const grant = {
      issuedTo: req.requestedBy,
      company: req.company,
      emailAdrs: req.emailAdrs,
      expDate: dt,
      acValue: req.acValue,
      issuedBy: this.props.userLogin,
      dcapUser: "cituser",
      serverCreds: req.serverCreds,
    }
    return await this.ss.apiInsertData(url, grant)
  }
  customGrant(evt) {
    this.setState ({datePicker: true, prevIndex: this.actButtonIndex(evt)})
    evt.stopPropagation()
  }
  newDate (dt){
    this.setState({expDate: dt, datePicker: false}, this.approveCustom (dt))
  }
  blurCalendar(evt) {
    if (typeof evt?.target?.className !== 'string' || !evt.target?.className?.includes('react-datepicker'))
      this.setState({datePicker: false})
  }
  approveCustom (dt) {
    this.approve (this.state.prevIndex, dt)
  }
  async approveRequest (evt) {
    const dt = new Date()
    dt.setMonth(dt.getMonth() + 3)
    this.approve(this.actButtonIndex(evt), dt)
  }
  async approve (index, dt) {
    this.setState({saving: true})
    const resp = await this.addGrant (this.state.requests[index], dt)
    if (httpSuccess (resp.status)) {
      this.deleteRequest (index)
    }
    else {
      const msg = resp?.message ?? "Request failed with status "+resp.status
      this.setState({errMsg: msg})
    }
    this.setState({saving: false, prevIndex: undefined})
  }
  async denyRequest (evt) {
    const index = this.actButtonIndex(evt)
    this.deleteRequest(index)
  }
  async deleteRequest (index) {
    const url = urlDeleteGrantRequest(this.state.requests[index].entryId)
    const delBody = {
      rbcTarget: this.state.requests[index].rbcTarget,
      serverCreds: this.state.requests[index].serverCreds,
      acValue: this.state.requests[index].acValue
    }
    const resp = await this.ss.apiDeleteData(url, delBody)
    if (httpSuccess (resp.status)) {
      this.initState()
    }
    else {
      const msg = resp?.message ?? "Request failed with status "+resp.status
      this.setState({errMsg: msg})
    }
  }
  renderHeader() {
    const title = this.state.requests?.length > 0  ? 
      "You have "+this.state.requests?.length+" grant requests" :
      "There are no pending grant requests"
    return (
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
    )    
  }
  tableButtons (index) {
    return (
    <div className='act-column'>
      <span className="actButton" name="approve" index={index} >
        <FontAwesomeIcon style={{color: 'darkgreen'}} icon={faThumbsUp} size="lg" onClick={this.approveRequest}/>
      </span>
      <span className="actButton" name="deny" index={index} onClick={this.denyRequest}>
        <FontAwesomeIcon style={{color: 'darkred'}} icon={faThumbsDown} size="lg"/>
      </span>
      <span className='actButton' name="custom" index={index} >
        <ExpireInput open={this.state.datePicker} onChange={this.newDate} onClick={this.customGrant}
          from={this.state.expDate} buttonInput='1'/>
      </span>
    </div>
    )
  }
  tableHead () {
    const titles = ['Request Date', 'Access Code', 'Site Name', 'Requested By', 'Company', 'Action']
    return (
      <thead>
        <tr className="csv-tr">
          {titles.map((item, index) => <th className="csv-td" key={index}>{item}</th> )}
        </tr>
      </thead>
    )
  }

  renderTab1(req) {
    if (!req) 
      return null
    if (this.state.saving)
      return this.state.loader
    const asIsCols= ['requestDate', 'acValue', 'siteName', 'requestedBy','company']
    return(
      <Modal.Body className='body-indent'>
       <table className="csv-table" id="dispTable">
        {this.tableHead()}
          <tbody>
          {req.map((r, index) => 
            <RowOfChildren id={index} key={index}>
              {asIsCols.map(i=> <GridText value={r[i]} key={index} />)}
              {this.tableButtons(index)}
            </RowOfChildren>
          )}
          </tbody>
        </table>
      </Modal.Body>
    )
  }

  render() {
    const req = this.state.requests
    return(
      <Modal show={this.props.show} onHide={this.handleClose} size="xl" onClick={this.blurCalendar}>
        {this.renderHeader()}
        {this.renderTab1(req)}
        <Modal.Footer>
          <div className="modal-error">{this.state.errMsg}</div>
          <Button className="custom-std-btn" onClick={()=>this.handleClose()} 
            disabled={this.state.saving}>Done</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}
